import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stateInput", "scheduledField"]

  connect() {
    this.toggleScheduledField()
  }

  toggleScheduledField() {
    const state = this.stateInputTarget.value
    const isScheduled = state === "scheduled"
    this.scheduledFieldTarget.disabled = !isScheduled

    if (isScheduled) {
      this.scheduledFieldTarget.classList.remove("bg-gray-50", "text-gray-400", "cursor-not-allowed")
    } else {
      this.scheduledFieldTarget.classList.add("bg-gray-50", "text-gray-400", "cursor-not-allowed")
    }
  }
}
